module.exports = __webpack_public_path__ + "img/home-lazer.2802612c.svg";